import {
  CreateButton,
  Datagrid,
  Filter,
  TextField,
  TextInput,
  useListContext,
} from "react-admin";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { Portrait } from "@material-ui/icons";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { IResourceListProps } from "../../common/ra-types";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";

interface Props extends IResourceListProps {}

const ListFilter = (props: any) => {
  const { loading } = useListContext();
  useSearchFields(props, ["email", "userName", "name", "surname"]);
  return (
    <Filter {...props}>
      {!loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
          autoFocus
          autoComplete="off"
        />
      )}
      {loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
        />
      )}
    </Filter>
  );
};

const ListActions = () => {
  const { basePath } = useListContext();

  return (
    <>
      <CreateButton basePath={basePath} />
    </>
  );
};

export const DemoAccountsList = (props: Props) => {
  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={Portrait} />}
        className="content-list"
        title="Demo Accounts"
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        sort={{ field: "email", order: "ASC" }}
        {...props}
      >
        <Datagrid>
          <TextField label="Login email" source="email" />
          <TextField label="Showing data from customer" source="tenantName" />
          <ActionsField
            hasShow={props.hasShow}
            editable={(x) => x.editable}
            canActivateOrDeactivate={() => false}
          >
            <DeleteRecordMenuItem />
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
